import { BASE_URL, getCookie } from '../../conf/config';

// For the help window, which has no UserProvider: the login token straight from the cookie
export const cookieFetch = (url, options = {}) =>
  fetch(url, { ...options, headers: { ...options.headers, Authorization: `Bearer ${getCookie('access_token')}` } });

async function post(fetchFn, path, body) {
  try {
    const response = await fetchFn(`${BASE_URL}/api/assistant/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (response.status === 401) return { ok: false, error: 'Your login has expired. Please reload the app.' };
    if (response.status === 429) return { ok: false, error: 'Many questions in a short time. Please wait a few minutes.' };
    const data = await response.json().catch(() => ({}));
    if (!response.ok) return { ok: false, error: data.errors?.[0] || 'The assistant is not available right now.' };
    return { ok: true, data };
  } catch (e) {
    return { ok: false, error: 'The server could not be reached.' };
  }
}

// payload: {question, page, selection: [{status}], history: [{question, answer}]}
export const askAssistant = (fetchFn, payload) => post(fetchFn, 'ask/', payload);
// comment: with a 👎, what was wrong or missing (optional)
export const rateAnswer = (fetchFn, id, rating, comment) =>
  post(fetchFn, 'rate/', comment ? { id, rating, comment } : { id, rating });
export const forwardQuestion = (fetchFn, id) => post(fetchFn, 'forward/', { id });
